export var BoardType;
(function (BoardType) {
    BoardType["Volleyball"] = "Volleyball";
    BoardType["VolleyballHalf"] = "VolleyballHalf";
    BoardType["Basketball"] = "Basketball";
    BoardType["BasketballHalf"] = "BasketballHalf";
    BoardType["Soccer"] = "Soccer";
    BoardType["SoccerHalf"] = "SoccerHalf";
    BoardType["IceHockey"] = "IceHockey";
    BoardType["IceHockeyHalf"] = "IceHockeyHalf";
    BoardType["Rugby"] = "Rugby";
    BoardType["RugbyHalf"] = "RugbyHalf";
    BoardType["Baseball"] = "Baseball";
    BoardType["Cricket"] = "Cricket";
})(BoardType || (BoardType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9hcmQtdHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zcG9ydHMvYm9hcmQtdHlwZS9ib2FyZC10eXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLFNBYVg7QUFiRCxXQUFZLFNBQVM7SUFDbkIsc0NBQXlCLENBQUE7SUFDekIsOENBQWlDLENBQUE7SUFDakMsc0NBQXlCLENBQUE7SUFDekIsOENBQWlDLENBQUE7SUFDakMsOEJBQWlCLENBQUE7SUFDakIsc0NBQXlCLENBQUE7SUFDekIsb0NBQXVCLENBQUE7SUFDdkIsNENBQStCLENBQUE7SUFDL0IsNEJBQWUsQ0FBQTtJQUNmLG9DQUF1QixDQUFBO0lBQ3ZCLGtDQUFxQixDQUFBO0lBQ3JCLGdDQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFiVyxTQUFTLEtBQVQsU0FBUyxRQWFwQiJ9